const accountingProduct = {
  id: '26231',
  name: 'Full Accounting Service (Simple plan) - nothing to pay for the first month, then £49 +VAT/month',
};

const whatHappensNext = {
  default: [
    { heading: 'Checkout', text: 'Complete checkout, enter your company details and choose a business bank account (optional).' },
    { heading: 'ID verification', text: 'We handle ID verification and submit your application.' },
    { heading: 'Confirmation', text: 'Most companies are registered within 24 hours, with documents emailed to you minutes later.' },
  ],
  'all-inclusive-accounting': [
    { heading: 'Checkout', text: 'Complete checkout, enter your company details and choose a business bank account (optional).' },
    { heading: 'ID verification', text: 'We handle ID verification and submit your application - most companies are registered within 24 hours, with documents emailed to you minutes later.' },
    { heading: 'Set up accounting', text: 'Complete our short onboarding, and your accounting service and Xero will be set up within 48 hours.' },
  ],
  'limited-by-guarantee': [
    { heading: 'Checkout', text: 'Complete checkout and enter your company details.' },
    { heading: 'ID verification', text: 'We handle ID verification and submit your application.' },
    { heading: 'Confirmation', text: 'Most companies are registered within 24 hours, with documents emailed to you minutes later.' },
  ],
  'non-residents': [
    { heading: 'Checkout', text: 'Complete checkout and enter your company details.' },
    { heading: 'ID verification', text: 'We handle ID verification and submit your application - most companies are registered within 24 hours.' },
    { heading: 'Confirmation', text: "We'll email your company documents along with links to sign up with one of our business bank account partners (optional)." },
  ],
};

$(document).ready(function () {
  $('#efOptionalTable').hide();
  loadCheckout();
  initProductTooltips();

  $(document).on('click', function (e) {
    if ($('.ui-dialog').length) {
      if (!$(e.target).parents().filter('.ui-dialog').length) {
        $('.ui-dialog-content').dialog('close');
      }
    }
  });
});

/* Product tooltip: matches the .infobox pattern used site-wide (hover on desktop, click on mobile/tablet).
   980 must match the .infobox "desktop" CSS breakpoint (1150px) - below that the box is a full-screen
   fixed overlay, so hover must not be the trigger or it flashes open on mouseover. */
const INFOBOX_DESKTOP_BREAKPOINT = 1150;

/* The CSS vertically centers the infobox on its icon (top: 50%; transform: translateY(-50%)),
   which cuts the box off above the viewport for long tooltips on products near the top of the
   page. This clamps the box on-screen and moves the triangle within it so it still points at
   the icon's actual position instead of staying pinned to the box's centre. */
const INFOBOX_VIEWPORT_MARGIN = 16;

function positionInfobox($wrapper, $infobox) {
  const iconRect = $wrapper[0].getBoundingClientRect();
  const iconCenterY = iconRect.top + iconRect.height / 2;
  const boxHeight = $infobox.outerHeight();
  const viewportHeight = $(window).height();

  const maxTop = Math.max(viewportHeight - boxHeight - INFOBOX_VIEWPORT_MARGIN, INFOBOX_VIEWPORT_MARGIN);
  const boxTop = Math.min(Math.max(iconCenterY - boxHeight / 2, INFOBOX_VIEWPORT_MARGIN), maxTop);

  $infobox.css({ top: boxTop - iconRect.top + 'px', transform: 'none' });

  /* The triangle is positioned relative to .infobox__wrapper, not .infobox itself (the box's
     border insets the wrapper a few px), so measure the wrapper directly instead of assuming
     it lines up with the box's own top. */
  const wrapperTop = $infobox.find('.infobox__wrapper')[0].getBoundingClientRect().top;
  $infobox.find('.infobox__triangle').css({ top: iconCenterY - wrapperTop + 'px' });
}

function initProductTooltips() {
  /* Bound to the tooltip wrapper (icon + popover together), not just the icon, so moving the
     mouse from the icon onto the popover never counts as leaving - that's what caused the flicker. */
  $(document).on('mouseenter', '.checkout__product .checkout__product__tooltip', function () {
    if ($(window).width() < INFOBOX_DESKTOP_BREAKPOINT) return;
    const $wrapper = $(this);
    const $infobox = $wrapper.find('.infobox');
    $infobox.find('.infobox__triangle').remove();
    $infobox.find('.infobox__close').before('<span class="infobox__triangle"></span>');
    $infobox.addClass('infobox--active');
    positionInfobox($wrapper, $infobox);
  });

  $(document).on('mouseleave', '.checkout__product .checkout__product__tooltip', function () {
    if ($(window).width() < INFOBOX_DESKTOP_BREAKPOINT) return;
    const $infobox = $(this).find('.infobox');
    $infobox.removeClass('infobox--active');
    $infobox.find('.infobox__triangle').remove();
    $infobox.css({ top: '', transform: '' });
  });

  $(document).on('click', '.checkout__product .infobox-btn', function () {
    if ($(window).width() >= INFOBOX_DESKTOP_BREAKPOINT) return;
    $(this).siblings('.infobox').addClass('infobox--active');
  });

  $(document).on('click', '.checkout__product .infobox__close', function () {
    $(this).closest('.infobox').removeClass('infobox--active');
  });

  $(document).on('click', '.checkout__product .infobox', function (e) {
    if ($(window).width() >= INFOBOX_DESKTOP_BREAKPOINT) return;
    if ($(e.target).closest('.infobox__content').length) return;
    $(this).removeClass('infobox--active');
  });
}

$('#efPackageCheckoutButton').click(function (event) {
  event.preventDefault();
  saveOptionalExtras();
});

function loadEligibleCountriesList() {
  let $dialog = $('#eligible-countries-dialog');

  if (!$dialog.length) {
    $dialog = $('<div id="eligible-countries-dialog" title="Eligible Countries" style="display:none;">' + '<p>Last updated: <span id="last-updated"></span></p>' + '<ul></ul>' + '</div>').appendTo('body');
  }

  if ($dialog.data('loaded')) {
    $dialog.dialog('open');
    return;
  }

  $.ajax({
    url: 'https://dev.1stformations.co.uk/items/eligible_countries',
    method: 'GET',
    dataType: 'json',
    success: function (json) {
      $dialog.find('span#last-updated').text(json.data.last_updated);
      let countriesHTML = '';
      json.data.countries.forEach(function (country) {
        countriesHTML += '<li>' + country + '</li>';
      });
      $(countriesHTML).appendTo($dialog.find('ul'));
      $dialog.data('loaded', true);
      $dialog.dialog({
        modal: !0,
        height: 400,
        width: 550,
      });
    },
    error: function (xhr, status, error) {
      console.error('Error:', error);
    },
  });
}

function loadCheckout() {
  const orderPackageVal = $('#order-package').val();
  const packageSlug = orderPackageVal === '##PACKAGE_SLUG#' ? 'digital-package' : orderPackageVal;
  fetchPackageDescriptions(packageSlug);

  $('input[type="button"][value="Add"]').addClass('efOrderButton');
  $('input[type="button"][value="Checkout"]').addClass('efOrderButton efCheckoutButton');
  $('#efPackageOptionalItemsTitle').text('Customers also bought');

  $(
    '<table class="efTable efPackageTable ui-widget-content" id="efOptionalIncludedTableAfter" style="display: table;"><tbody><tr class="ui-widget-header" style="border-left-color:#fff;border-right-color:#fff;"><td colspan="4" style="text-align:right;">Net:</td><td style="text-align:right;" width="45">£0.00</td></tr><tr class="ui-widget-header" style="border-left-color:#fff;border-right-color:#fff;"><td colspan="4" style="text-align:right;">VAT:</td><td style="text-align:right;">£0.00</td></tr></tbody></table>',
  ).insertAfter($('#efOptionalIncludedTable'));

  $('#efPackageNet').css('display', 'none');
  $('#efPackageTax').css('display', 'none');
  $('#efOptionalIncludedTableAfter > tbody > tr:first > td:last').html('&pound;' + currency_format(packnetprice));
  $('#efOptionalIncludedTableAfter > tbody > tr:last > td:last').html('&pound;' + currency_format(parseFloat(packprice) - parseFloat(packnetprice)));
  $('.sticky-checkout-bar').length && $('.sticky-checkout-bar span').html('£' + currency_format(packprice));

  if ($('[onclick*="remove_product"]').length)
    $('[onclick*="remove_product"]').each(function (e) {
      $(this).attr('onclick', $(this).attr('onclick').replace('remove_product(', 'removeProduct('));
    });
  if ($('[onclick*="add_product"]').length)
    $('[onclick*="add_product"]').each(function (e) {
      $(this).attr('onclick', $(this).attr('onclick').replace('add_product(', 'addProduct('));
    });

  fixCheckoutWrapper();
  fixBasket();
  showAccountingOfferNote();
  showTrustpilotWidget();
  // showPaymentCardIcons();
  showPackageName();
  showCompanyName();
  if (isCheckoutPackage('all-inclusive-accounting')) {
    addAccountingInfoBox();
  } else {
    addEligibleCountriesBox();
  }
  showStickyCheckoutBar();

  $('#efContinueExistingPackageOrder').hide();
  $('#efPackagePurchaseOptionsContainer').show();

  $('.section--buy #efPageContent').show();

  fixOptionalProducts();
  revealCheckout();
}

function loadContinueOrder() {
  $('.section--buy #efPageContent').show();
  $('<h3>Checkout</h3>').insertBefore($('#efContinueExistingPackageOrder p'));
  $('#efContinueExistingPackageOrder button.deleteButton').addClass('efErrorButton');
  $('#efContinueExistingPackageOrder button.deleteButton span.ui-button-text').text('Delete');
  $('#efContinueExistingPackageOrder button.efButton span:contains("Pay Now")').text('Pay Now');
  $('#efContinueExistingPackageOrder #efPackageNewOrderButton').addClass('efOrderButton');
  $('#efContinueExistingPackageOrder #efPackageNewOrderButton span').text('Start New Order');
}

function showPackageName() {
  const packageName = $('#package-name').val();
  let packageNameHTML = '<tr class="efIncludedItemTableRow efEven">';
  packageNameHTML += '<td colspan="2"><strong>' + packageName + '</strong></td>';
  packageNameHTML += '<td>£' + currency_format(parseFloat(packnetprice)) + '</td>';
  packageNameHTML += '</tr>';
  $(packageNameHTML).prependTo($('#efIncludedTable tbody'));
}

function showCompanyName() {
  const urlParams = new URLSearchParams(window.location.search);
  const isSet = urlParams.get('gle') === 'namecheck';
  const companyName = urlParams.get('name');

  if (isSet && companyName.length > 0) {
    let companyNameHTML = '<div class="checkout__companyName" style="display: none">';
    companyNameHTML += '<h3>Your Company Name</h3>';
    companyNameHTML += '<p><i class="fas fa-check-circle"></i> ' + companyName + '</p></div>';
    $(companyNameHTML).insertBefore($('#efPackageIncludedItemsTitle'));
  }
}

function showWhatHappensNext() {
  let steps = whatHappensNext.default;
  if (isCheckoutPackage('non-residents')) {
    steps = whatHappensNext['non-residents'];
  } else if (isCheckoutPackage('limited-by-guarantee')) {
    steps = whatHappensNext['limited-by-guarantee'];
  } else if (isCheckoutPackage('all-inclusive-accounting')) {
    steps = whatHappensNext['all-inclusive-accounting'];
  }

  let html = '<div class="checkout-next-steps"><h3>What happens next</h3><div class="checkout-next-steps__list">';
  steps.forEach(function (step, index) {
    const isLast = index === steps.length - 1;
    html += '<div class="checkout-next-steps__step">';
    html += '<div class="checkout-next-steps__rail"><span class="checkout-next-steps__number">' + (index + 1) + '</span>';
    if (!isLast) {
      html += '<span class="checkout-next-steps__line"></span>';
    }
    html += '</div>';
    html += '<div class="checkout-next-steps__content"><h4>' + step.heading + '</h4><p>' + step.text + '</p></div>';
    html += '</div>';
  });
  html += '</div></div>';
  $(html).insertAfter($('#efEverythingOptionalContainer'));
}

function isCheckoutPackage(slug) {
  return window.location.pathname.indexOf(slug) > -1;
}

function showAccountingOfferNote() {
  const isEligiblePackage = isCheckoutPackage('all-inclusive-accounting');
  if (!isEligiblePackage && !isStagingEnvironment()) return;

  let html = '<div class="checkout__accounting-note"' + (isEligiblePackage ? '' : ' style="display: none;"') + '>';
  html += '<p><strong>By choosing this £39.99 offer</strong>, you agree to subscribe to our accounting service. Nothing to pay for one month, then 11 payments from £49 per month, rolling monthly after that.</p>';
  html += '</div>';

  $(html).insertBefore($('#efPackageCheckout'));

  addAccountingNoteDebugToggle();
}

function isStagingEnvironment() {
  return window.location.hostname === 'f89913-web.efiling-stage.co.uk';
}

function addAccountingNoteDebugToggle() {
  if (!isStagingEnvironment() || $('#accounting-note-debug-toggle').length) return;

  $('<button type="button" id="accounting-note-debug-toggle">Toggle £1 offer note</button>')
    .css({
      position: 'absolute',
      top: '10px',
      left: '10px',
      zIndex: 9999,
      padding: '0.4rem 0.75rem',
      fontSize: '0.75rem',
      fontFamily: 'sans-serif',
      background: '#131416',
      color: '#fff',
      border: 'none',
      borderRadius: '0.25rem',
      cursor: 'pointer',
    })
    .appendTo('body')
    .on('click', function () {
      $('.checkout__accounting-note').toggle();
    });
}

function showTrustpilotWidget() {
  let html = '<div class="checkout__trustpilot">';
  html += '<div class="trustpilot-widget" data-locale="en-US" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="539f1c8c000064000578efba" data-style-height="50px" data-style-width="260px" data-token="8737925e-bad5-4118-96f1-cc7a0bd116f8">';
  html += '<a href="https://www.trustpilot.com/review/www.1stformations.co.uk" target="_blank" rel="noopener">Trustpilot</a>';
  html += '</div></div>';

  const $widget = $(html).insertAfter($('#efPackageCheckout'));

  if (window.Trustpilot) {
    window.Trustpilot.loadFromElement($widget.find('.trustpilot-widget')[0], true);
  }
}

function showPaymentCardIcons() {
  let html = '<div class="checkout__card-icons">';
  html += '<div class="checkout__card-icons__icon"><img width="48" height="34" loading="lazy" src="https://1stformations.s3-eu-west-1.amazonaws.com/assets/live/images/svg/visa.svg" alt="Visa" title="Visa" /></div>';
  html += '<div class="checkout__card-icons__icon"><img width="48" height="34" loading="lazy" src="https://1stformations.s3-eu-west-1.amazonaws.com/assets/live/images/svg/mastercard.svg" alt="Mastercard" title="Mastercard" /></div>';
  html += '<div class="checkout__card-icons__icon"><img width="48" height="34" loading="lazy" src="https://1stformations.s3-eu-west-1.amazonaws.com/assets/live/images/svg/maestro.svg" alt="Maestro" title="Maestro" /></div>';
  html += '<div class="checkout__card-icons__icon"><img width="48" height="34" loading="lazy" src="https://1stformations.s3-eu-west-1.amazonaws.com/assets/live/images/svg/amex.svg" alt="American Express" title="American Express" /></div>';
  html += '<div class="checkout__card-icons__icon"><img width="48" height="34" loading="lazy" src="https://cdn-quality.s3.eu-central-1.amazonaws.com/assets/live/images/banking+logos/apple-pay.svg" alt="Apple Pay" title="Apple Pay" /></div>';
  html += '<div class="checkout__card-icons__icon"><img width="48" height="34" loading="lazy" src="https://cdn-quality.s3.eu-central-1.amazonaws.com/assets/live/images/banking+logos/g-pay.svg" alt="Google Pay" title="Google Pay" /></div>';
  html += '</div>';

  $(html).insertAfter($('.checkout__trustpilot'));
}

function fixCheckoutWrapper() {
  let checkoutWrapperHTML = '<div class="checkout__boxes">';
  checkoutWrapperHTML += '<div class="checkout__wrapper">';
  checkoutWrapperHTML += '<div class="checkout__box checkout__box--basket"></div>';
  checkoutWrapperHTML += '<div class="checkout__box checkout__box--items"></div>';
  checkoutWrapperHTML += '</div></i>';
  $(checkoutWrapperHTML).appendTo($('#package-form'));
  $('#efEverythingInTheOrderContainer').appendTo($('.checkout__box--basket'));
  $('#efEverythingOptionalContainer').appendTo($('.checkout__box--items'));
  showWhatHappensNext();
}

function fixBasket() {
  $('<div class="checkout__basket"></div>').insertBefore($('#efIncludedTable'));
  $('#efIncludedTable').appendTo($('.checkout__basket'));
  $('#efOptionalIncludedTable').appendTo($('.checkout__basket'));
  $('#efOptionalIncludedTableAfter').appendTo($('.checkout__basket'));
  $('#efPackageNet').appendTo($('.checkout__basket'));
  $('#efPackageTax').appendTo($('.checkout__basket'));
  $('#efPackageTotal').appendTo($('.checkout__basket'));
  $('#efPackageAgreeTerms').appendTo($('.checkout__basket'));
  $('#efPackageCheckout').appendTo($('.checkout__basket'));

  $('<h3>Your basket</h3>').insertBefore($('#efIncludedTable'));

  $('#efPackageIncludedItemsTitle').remove();
  $('.efIncludedItemTableRow td[colspan="3"]').attr('colspan', '');
  $('#efIncludedTable td:contains("Quantity")').text('');
  $('#efIncludedTable tr.ui-widget-header td:last-child').text('Price');
  $('input[type="button"][value="X"]').addClass('efRemoveButton');
}

function fixOptionalProducts() {
  const productOrdering = [accountingProduct.id, '25869', '2047', '2046', '10698', '22183', '22185', '22188', '2051', '2052', '13529', '16458', '6986', '24305', '2048', '2049', '19493', '4750', '25796', '26236', '26249', '19769', '20493', '13592'];
  const categories = ['Accounting', 'Address', 'Finance', 'Telephony', 'Other'];
  const hiddenTypes = ['Documents'];
  let optionalProductsHTML = '<div class="checkout__categories">';
  for (let i = 0; i < categories.length; i++) {
    optionalProductsHTML += '<div class="checkout__category" data-category="' + categories[i] + '">';
    optionalProductsHTML += '<div class="checkout__products"></div>';
    optionalProductsHTML += '<div class="checkout__divider"></div></div>';
  }
  optionalProductsHTML += '</div>';

  $(optionalProductsHTML).insertBefore($('#efOptionalTable'));

  for (let j = 0; j < productOrdering.length; j++) {
    const product = $('#optional_' + productOrdering[j]);
    if (product.length > 0) {
      const productId = product.attr('id').replace('optional_', '');
      const productName = productId === accountingProduct.id ? accountingProduct.name : product.find('td:nth-child(1)').text();
      const tooltipHTML = ($('#efMoreInfo_' + productId).html() || '').trim();
      let productPrice = product.find('.efPriceInPackage').text();
      if (productPrice === '£0.00') productPrice = 'Free';

      const productType = getProductType(productName);
      const hasQuantity = product.find('input[id^="optional_quantity"][type!="hidden"]').length > 0;
      let productHTML = '<div class="checkout__product" data-id="' + productId + '" data-category="' + productType + '" data-hidden="false">';
      productHTML += '<div class="checkout__product__info">';
      productHTML += '<h4>' + productName + '</h4>';
      productHTML += '<p class="checkout__product__skeleton" aria-hidden="true"><span></span><span></span></p>';
      productHTML += '</div>';
      productHTML += '<div class="checkout__product__tooltip">' + (tooltipHTML ? productTooltipHTML(tooltipHTML) : '') + '</div>';

      productHTML += '<div class="checkout__product__priceQuantity"><div class="checkout__product__price">' + productPrice + '</div>';
      if (hasQuantity) {
        productHTML += '<div data-id="' + productId + '"><input id="product_quantity_' + productId + '" value="1" class="efQuantity" type="number" max="10" min="1" step="1"></div></div>';
      } else {
        productHTML += '<div data-id="' + productId + '"><input id="product_quantity_' + productId + '" value="1" class="efQuantity" type="hidden"></div></div>';
      }
      productHTML += '<div class="checkout__product__buy">';
      productHTML += '<input type="button" value="Add" class="efButton efOrderButton ui-button ui-widget ui-state-default ui-corner-all" role="button" aria-disabled="false">';
      productHTML += '</div></div>';

      if (!hiddenTypes.includes(productType)) {
        $(productHTML).appendTo($('.checkout__category[data-category="' + productType + '"] .checkout__products'));
      }
    }
  }

  $('.checkout__category').each(function () {
    if ($(this).find('.checkout__products').children().length === 0) {
      $(this).hide();
    }
  });

  if (!isCheckoutPackage('all-inclusive-accounting')) {
    preAddProducts();
  }
}

function productTooltipHTML(contentHTML) {
  let html = '<span class="infobox-btn"><i class="fa-regular fa-info-circle"></i></span>';
  html += '<div class="infobox"><div class="infobox__wrapper"><a class="infobox__close">&times;</a><div class="infobox__content">' + contentHTML + '</div></div></div>';
  return html;
}

/* Descriptions come from an ajax call, so they're filled in after the products are rendered rather than
   holding the whole checkout hidden until it returns. Products without eFiling "more info" markup
   fall back to the description for their tooltip, same as before. */
function applyProductDescriptions(packageProducts) {
  packageProducts.forEach(function (details) {
    if (!details.description) return;
    const $product = $('.checkout__product[data-id="' + details.id + '"]');
    if (!$product.length) return;
    $product.find('.checkout__product__skeleton').removeClass('checkout__product__skeleton').removeAttr('aria-hidden').html(details.description);
    const $tooltip = $product.find('.checkout__product__tooltip');
    if ($tooltip.is(':empty')) {
      $tooltip.html(productTooltipHTML('<p>' + details.description + '</p>'));
    }
  });
}

function getProductType(name) {
  if (/Telephone|Bizik|Live Chat/.test(name)) {
    return 'Telephony';
  } else if (/Accounting/.test(name)) {
    return 'Accounting';
  } else if (/Submission|VAT|PAYE|Cancellation|Guaranteed|ICO/.test(name)) {
    return 'Finance';
  } else if (/Service Address|Registered Office|Business Address/.test(name)) {
    return 'Address';
  } else if (name.indexOf('Standard Document') > -1) {
    return 'Documents';
  } else {
    return 'Other';
  }
}

function saveOptionalExtras() {
  const optionalProducts = [];

  $('#efOptionalIncludedTable .efOptionalTrProduct').each(function () {
    const id = $(this).attr('id').replace('optional_included_', '');
    const name = $(this)[0].children[0].innerText;
    const price = $(this)[0].children[2].innerText;
    const quantity = $(this)[0].children[0].children[0].value;
    const product = {
      id: parseInt(id, 10),
      name: name,
      price: price,
      quantity: parseInt(quantity, 10),
    };

    if (id !== '2051') optionalProducts.push(product);
  });

  Cookies.set('orderCart', JSON.stringify(optionalProducts), { path: '/' });
}

function preAddProducts() {
  addProduct(2051, false);
  const optionalExtras = Cookies.get('orderCart') ? JSON.parse(Cookies.get('orderCart')) : [];

  if (optionalExtras && optionalExtras.length > 0) {
    optionalExtras.forEach(function (product) {
      if ($('.checkout__product[data-id="' + product.id + '"]').length > 0) {
        $('#product_quantity_' + product.id).val(product.quantity);
        addProduct(product.id, false);
      }
    });
  }
}

function addProduct(id, animate) {
  if (animate === undefined) animate = true;
  const sameDayProduct = { id: 1447, price: 79.99 };
  const element = $('.checkout__product[data-id="' + id + '"]');
  element.attr('data-hidden', 'true');
  if (animate) {
    element.hide('fade');
  } else {
    element.hide();
  }

  let quantity = parseInt($('#product_quantity_' + id).val());
  if (isNaN(quantity)) quantity = 1;

  const pkey = 'P' + id;
  let factorial = 1;
  const tax = taxesnotbetaxin[pkey];

  if (quantity > 1) factorial = multibuy_discount[pkey];

  let price = quantity * prices[pkey] * tax * factorial;
  price = currency_format(price);
  price = parseFloat(price);

  const netprice = quantity * prices[pkey] * factorial;
  let dprice;
  if (display_incvat === '1') {
    dprice = price;
  } else {
    dprice = netprice;
  }

  const ptype = types[pkey];
  let html = '';
  html = html += '<tr id="optional_included_' + id + '" class="efOptionalTrProduct" data-id="' + id + '">\n';
  if (quantity > 1) {
    html += '<td colspan="3">' + names[pkey] + ' x' + quantity + ' <input type="hidden" id="optional_included_quantity_' + id + '" name="quantity[' + pkey + ']" value="' + quantity + '"></td>\n';
  } else {
    html += '<td colspan="3">' + names[pkey] + ' <input type="hidden" id="optional_included_quantity_' + id + '" name="quantity[' + pkey + ']" value="' + quantity + '"></td>\n';
  }
  html += '<td style="text-align:right"><input type="button" class="efButton efRemoveButton" value=\'x\' /></td>\n';
  html += '<td style="text-align:right">&pound;' + currency_format(id === sameDayProduct.id ? sameDayProduct.price : dprice) + '</td>\n';
  html += '</tr>\n';

  let feeprice = 0;

  if (fees[pkey] > 0) {
    feeprice = quantity * fees[pkey];
    html += '<tr id="optional_included_' + id + '_fee">\n';
    html += '<td colspan="3">' + feenames[pkey] + ' x' + quantity + '</td>\n';
    html += '<td style="text-align:right"></td>\n';
    html += '<td style="text-align:right">&pound;' + currency_format(feeprice) + '</td>\n';
    html += '</tr>\n';
  }

  $('#efOptionalIncludedTable').show();
  $('#efOptionalIncludedTable').append(html);
  $('.efButton').button();
  $('#optional_' + id).hide();

  packprice = packprice + price + feeprice;
  packnetprice = packnetprice + netprice + feeprice;

  if (ptype === 'REGOFFICE' || ptype === 'MAILFORWARD' || ptype === 'MEMARTSDOC') {
    $('.optional_product_' + ptype).hide();
  }

  shuffle_tables();
  $('#efPackageTotal span').html('&pound;' + currency_format(packprice));
  $('#efPackageNet span').html('&pound;' + currency_format(packnetprice));
  $('#efPackageTax span').html('&pound;' + currency_format(parseFloat(packprice) - parseFloat(packnetprice)));
  $('#efOptionalIncludedTableAfter > tbody > tr:first > td:last').html('£' + currency_format(parseFloat(packnetprice)));
  $('#efOptionalIncludedTableAfter > tbody > tr:last > td:last').html('£' + currency_format(parseFloat(packprice) - parseFloat(packnetprice)));
  $('.sticky-checkout-bar').length && $('.sticky-checkout-bar span').html('£' + currency_format(packprice));
  redraw_classes();
  checkIfEmpty();
  toggleTelephoneProducts(id, 'hide');

  if (window.clarity) {
    window.clarity('set', 'product_id', pkey);
    window.clarity('set', 'product_name', names[pkey]);
    window.clarity('set', 'product_quantity', String(quantity));
    window.clarity('set', 'product_price', String(price));
    window.clarity('set', 'product_type', ptype);
    window.clarity('event', 'add_product');
  }
}

function removeProduct(id) {
  $('.checkout__product[data-id="' + id + '"]').show('fade');
  $('.checkout__product[data-id="' + id + '"]').attr('data-hidden', 'false');

  const pkey = 'P' + id;
  const tmpquantity = parseInt($('#optional_included_quantity_' + id).val());
  let factorial = 1;
  const tax = taxesnotbetaxin[pkey];
  if (tmpquantity > 1) factorial = multibuy_discount[pkey];
  const price = prices[pkey] * tax * tmpquantity * factorial + fees[pkey] * tmpquantity * 1;
  const netprice = prices[pkey] * tmpquantity * factorial + fees[pkey] * tmpquantity * 1;
  const fullprice = fullprices[pkey] * tax * tmpquantity * factorial + fees[pkey] * tmpquantity * 1;
  const baseprice = prices[pkey] * tax + fees[pkey];
  const basenetprice = prices[pkey] + fees[pkey];
  const ptype = types[pkey];
  let dbaseprice;
  if (display_incvat === '1') {
    dbaseprice = baseprice;
  } else {
    dbaseprice = basenetprice;
  }

  $('.efButton').button();
  $('#optional_included_' + id).remove();

  if ($('#optional_included_' + id + '_fee').length > 0) {
    $('#optional_included_' + id + '_fee').remove();
  }

  packprice = packprice - price;
  packnetprice = packnetprice - netprice;

  if (ptype === 'REGOFFICE' || ptype === 'MAILFORWARD' || ptype === 'MEMARTSDOC') {
    $('.optional_product_' + ptype).show();
  }
  shuffle_tables();
  $('#efPackageTotal span').html('&pound;' + currency_format(packprice));
  $('#efPackageNet span').html('&pound;' + currency_format(packnetprice));
  $('#efPackageTax span').html('&pound;' + currency_format(parseFloat(packprice) - parseFloat(packnetprice)));
  $('#efOptionalIncludedTableAfter > tbody > tr:first > td:last').html('&pound;' + currency_format(parseFloat(packnetprice)));
  $('#efOptionalIncludedTableAfter > tbody > tr:last > td:last').html('&pound;' + currency_format(parseFloat(packprice) - parseFloat(packnetprice)));
  $('.sticky-checkout-bar').length && $('.sticky-checkout-bar span').html('£' + currency_format(packprice));
  redraw_classes();
  checkIfEmpty();
  toggleTelephoneProducts(id, 'show');

  if (window.clarity) {
    window.clarity('set', 'product_id', pkey);
    window.clarity('set', 'product_name', names[pkey]);
    window.clarity('set', 'product_quantity', String(tmpquantity));
    window.clarity('set', 'product_price', String(price));
    window.clarity('set', 'product_type', ptype);
    window.clarity('event', 'remove_product');
  }
}

function checkIfEmpty() {
  $('.checkout__category').each(function () {
    const productsHidden = $(this).find('.checkout__product[data-hidden="true"]').length;
    const totalProducts = $(this).find('.checkout__product').length;
    if (productsHidden >= totalProducts) {
      $(this).addClass('checkout__category--hide');
    } else {
      $(this).removeClass('checkout__category--hide');
    }
  });
}

function toggleTelephoneProducts(id, toggle) {
  if (id === 4751 || id === 13589) {
    if (toggle === 'hide') {
      $('.checkout__product[data-id="4751"]').attr('data-hidden', 'true').hide('fade');
      $('.checkout__product[data-id="13589"]').attr('data-hidden', 'true').hide('fade');
    } else {
      $('.checkout__product[data-id="4751"]').attr('data-hidden', 'false').show('fade');
      $('.checkout__product[data-id="13589"]').attr('data-hidden', 'false').show('fade');
    }

    checkIfEmpty();
  }
}

function addEligibleCountriesBox() {
  let eligibleCountriesHTML = '<div class="checkout__eligible-countries">';
  eligibleCountriesHTML += '<header><span><i class="fa-thin fa-triangle-exclamation"></i></span>';
  eligibleCountriesHTML += '<h3>Live outside the UK? <br />Read this before you pay</h3></header>';
  eligibleCountriesHTML += '<footer><p>Check the <strong>Eligible Countries List</strong>. Orders from <br /> non-eligible countries are cancelled, minus a £19.99 +VAT admin fee.</p>';
  eligibleCountriesHTML += '<a href="#" aria-label="Open Eligible Countries List"></a>';
  eligibleCountriesHTML += '</footer></div>';

  const $eligibleCountriesBox = $(eligibleCountriesHTML).insertAfter($('#efEverythingInTheOrderContainer'));

  $eligibleCountriesBox.find('a').on('click', function (event) {
    event.preventDefault();
    loadEligibleCountriesList();
  });
}

function addAccountingInfoBox() {
  let accountingInfoHTML = '<div class="checkout__eligible-countries checkout__accounting-info">';
  accountingInfoHTML += '<header><span><i class="fa-thin fa-triangle-exclamation"></i></span>';
  accountingInfoHTML += '<h3>This package is for UK residents only</h3></header>';
  accountingInfoHTML += '<footer><p>If you live outside the UK, do not buy this package. Your order will be cancelled, minus a £19.99 +VAT admin fee.</p>';
  accountingInfoHTML += '<p>Live overseas? Choose our <a href="/package/non-residents/">Non-Residents Package</a> instead.</p>';
  accountingInfoHTML += '</footer></div>';

  $(accountingInfoHTML).insertAfter($('#efEverythingInTheOrderContainer'));
}

function showStickyCheckoutBar() {
  if ($(window).width() < 768) {
    let checkoutBarHTML = '<div class="sticky-checkout-bar">';
    checkoutBarHTML += '<h3>Order Total: <span></span></h3>';
    checkoutBarHTML += '<button id="sticky-checkout-button" class="sticky-checkout-bar__button" role="button" aria-disabled="false">Checkout</button>';
    checkoutBarHTML += '</div>';
    $(checkoutBarHTML).insertBefore($('#efPackagePurchaseOptionsContainer'));
    $('#efPackageCheckout').hide();
  }
}

function redirectToPackageCheckout(packageSlug) {
  window.location.href = '/buy/' + packageSlug + '/';
}

function fetchPackageDescriptions(packageSlug) {
  $.get('/ejax-lib-get-packages', { slug: packageSlug })
    .done(function (data) {
      const results = JSON.parse(data);
      applyProductDescriptions(results.packages[0].products);
    })
    .always(function () {
      /* Any skeleton still left belongs to a product with no description (or the request failed). */
      $('.checkout__product__skeleton').remove();
    });
}

/* Content is hidden by CSS until the rebuild is finished so eFiling's original markup doesn't flash. */
function revealCheckout() {
  $('.checkout').addClass('checkout--ready');
}

$(document).on('click', '.checkout__product__buy input[type="button"]', function () {
  const id = $(this).closest('.checkout__product').data('id');
  addProduct(id);
});

$(document).on('click', '.efRemoveButton', function () {
  const id = $(this).closest('.efOptionalTrProduct').data('id');
  removeProduct(id);
});

$('.checkout__product input[id^="product_quantity_"]').on('change', function () {
  const id = $(this).parent().attr('data-id');
  const quantity = $(this).val();
  $('#optional_quantity_' + id).val(quantity);
});

$('body').on('click', '#sticky-checkout-button', function () {
  $('#efPackageCheckoutButton').click();
});
